import { render, staticRenderFns } from "./chapter-edit.vue?vue&type=template&id=78007565"
import script from "./chapter-edit.vue?vue&type=script&lang=js"
export * from "./chapter-edit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports